<template>
    <div :class="node.classes">
        <div class="notify__notice-message" v-text="node.message" />
        <div v-if="node.description" class="notify__notice-description" v-text="node.description" />
        <button class="notify__notice-close" @click="node.onClose(node.key)">
            <component :is="node.closeIcon" />
        </button>
    </div>
</template>
<script>
export default {
    props: {
        node: {
            type: Object,
            required: true
        }
    }
};
</script>
